<template>
  <img :src="thumbImage" />
</template>

<script lang="ts">
import { computed, defineComponent, unref } from "vue";
import { consumableThumb } from "~/lib/thumbs";

export default defineComponent({
  name: "ConsumableThumb",
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const thumbImage = computed(() => {
      return unref(consumableThumb(props.id));
    });
    return {
      thumbImage,
    };
  },
});
</script>
